import { ApiResult, request, safeRequest } from '@synergy/api';

import { InternalNote } from '../models/internal-note';
import { InternalNoteFormValue } from '../components/internal-notes/internal-notes-modal';
import { PaloDraftNoteIds } from '../components/palo/palo-draft-notices';
import { ReceiptNoteType } from '../models/enums/receipt-note-type';

export class InternalNotesApi {
    constructor(protected baseUrl: string) {}

    public getInternalNotes(type: string, id: number): Promise<ApiResult<InternalNote[]>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/${type}/${id}/notes`),
            response => response.data
        );
    }

    public getReceiptNotes(type: ReceiptNoteType, id: number): Promise<ApiResult<InternalNote[]>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/notes/${type}/${id}`),
            response => response.data
        );
    }

    public getDraftNotes(type: ReceiptNoteType, ids: PaloDraftNoteIds): Promise<ApiResult<InternalNote[]>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/notes/${type}/draft`, ids),
            response => response.data
        );
    }

    public create(internalNote: InternalNoteFormValue, type: string, id: number): Promise<ApiResult<InternalNote>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/${type}/${id}/notes`, internalNote),
            response => response.data
        );
    }

    public update(internalNote: InternalNote): Promise<ApiResult<InternalNote>> {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/notes/${internalNote.id}`, internalNote),
            response => response.data
        );
    }

    public delete(id: number): Promise<ApiResult<void>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/notes/${id}`),
            response => response.data
        );
    }
}
